import { useAppDetails } from "@/contexts/AppDetailsContext";
import { cn } from "@/lib/utils";
import React, { ReactNode } from "react";

interface AssetBadgeProps {
  symbol?: string;
  timeframe?: string | ReactNode;
  logo?: string;
  size?: number; // optional - defaults to 55
  hideLogo?: boolean;
}

export const AssetBadge: React.FC<AssetBadgeProps> = ({
  symbol,
  timeframe,
  logo,
  size = 45,
  hideLogo = false,
}) => {
  const { details } = useAppDetails();
  return (
    <div className="flex items-center gap-2">
      {!details.isWhiteLabled && !hideLogo && (
        <div
          className="rounded-md overflow-hidden flex justify-center items-center "
          style={{ width: size, height: size }}
        >
          <img
            src={logo}
            alt={symbol}
            className={cn(
              `max-w-[${size}px] max-h-[${size}px] w-full h-full object-contain`,
            )}
          />
        </div>
      )}

      <div className="flex flex-col font-bold text-muted-foreground text-base">
        {symbol && <p className="text-white">{symbol}</p>}
        {timeframe && <p className="text-sm">{timeframe}</p>}
      </div>
    </div>
  );
};
